import View from './view';
import {useDispatch, useSelector} from 'react-redux';
import {notificationsSelector} from '../../../redux/selectors/snackbar';
import {removeNotification} from '../../../redux/actions/snackbar';

export const Snackbar = () => {
  const notifications = useSelector(notificationsSelector());
  const dispatch = useDispatch();

  const onCloseAdditional = (id: string) => {
    dispatch(removeNotification(id));
  };
  return View({
    notifications,
    onCloseAdditional,
  });
};
